import i18n from '../i18n';

const localeMap: Record<string, string> = {
  de: 'de-DE',
  en: 'en-GB',
  pl: 'pl-PL',
  fr: 'fr-FR',
};

const getLocaleForCurrentLanguage = (): string => {
  const lang = i18n.language?.split('-')[0] || 'en';
  return localeMap[lang] || 'en-GB';
};

/**
 * Formats a last-login date as:
 *  - "Today" (t('today')) if same day
 *  - "Yesterday" (t('yesterday')) if previous day
 *  - Localized date string for the current language
 *  - "–" when missing/invalid
 */
const formatLastLoginDate = (lastLogin: string | null | undefined): string => {
  if (!lastLogin) return '–';
  try {
    const date = new Date(lastLogin);
    if (isNaN(date.getTime())) return '–';

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const loginDate = new Date(date);
    loginDate.setHours(0, 0, 0, 0);

    const isSameDay = (d1: Date, d2: Date) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDay(loginDate, today)) {
      return i18n.t('today');
    }

    if (isSameDay(loginDate, yesterday)) {
      return i18n.t('yesterday');
    }

    const locale = getLocaleForCurrentLanguage();
    return date.toLocaleDateString(locale);
  } catch {
    return '–';
  }
};

export default formatLastLoginDate;